import { RolesEnum } from 'app/shared/enums/roles.enum';
import { Shop } from 'app/shared/models/shop.model';
import { UserStatusEnumDTO } from 'app/shared/models/user-info.model';
import { UtilityFunctions } from 'app/shared/utilities/functions.models';
import { UserCompanyTypeEnum } from '../enum/user-company-type.enum.model';
import { UserStatusVmEnum } from '../enum/user-status.enum.model';

import { RoleDTO, RoleVM } from '../models/users/role.models';
import { UserDTO, UserVM } from '../models/users/user.model';
import { AgencyMapper } from './agency-mapper';
import { CustomerMapper } from './customer-mapper';

export class UserMapper {
  public static UserVM(user: UserDTO, storeList: Shop[], currentStoreId: number): UserVM {
    const mainRole = +Object.keys(RolesEnum).find(x => isNaN(Number(RolesEnum[x])) && user.roles.some(el => el === RolesEnum[x]));
    const companyType = mainRole === RolesEnum.Administrator || mainRole === RolesEnum.StoreOwner || mainRole === RolesEnum.StoreUser || mainRole === RolesEnum.Designer ?
      UserCompanyTypeEnum.admin : user.customer ? UserCompanyTypeEnum.customer : user.agency ? UserCompanyTypeEnum.agency : UserCompanyTypeEnum.unassigned;
    return new UserVM({
      storeIds: user.storeIds || [],
      companyType: companyType,
      companyName: user.agency ? user.agency.name : user.customer ? user.customer.name : null,
      status: this.checkStatus(user.status, user),
      mainRole: mainRole,
      email: user.email,
      id: user.id,
      name: user.name,
      isNew: user.status === UserStatusEnumDTO.AwaitingAproval,
      roles: user.roles.filter(x => x !== RolesEnum[RolesEnum.Service]).map(y => UtilityFunctions.spliByUpperCase(y)),
      agency: user.agency ? AgencyMapper.AgencyListItemVM(user.agency) : null,
      customer: user.customer ? CustomerMapper.CustomerVM(user.customer, storeList, currentStoreId) : null,
      culture: user.culture,
      externalId: user.externalId,
      fullName: user.name + ' - ' + user.email
    });
  }

  private static checkStatus(userStatus: UserStatusEnumDTO, user: UserDTO) {
    let status = null;
    switch (userStatus) {
      case UserStatusEnumDTO.Enabled:
        if (user.identityId) {
          status = UserStatusVmEnum.active;
        } else {
          status = UserStatusVmEnum.invited;
        }
        break;
      case UserStatusEnumDTO.AwaitingAproval:
        status = UserStatusVmEnum.waitingForApproval;
        break;
      case UserStatusEnumDTO.Disabled:
        status = UserStatusVmEnum.disabled;
        break;
    }
    return status;
  }

  public static RoleVM(role: RoleDTO, checked?: boolean, currentRole: RolesEnum = null): RoleVM {
    return new RoleVM({
      checked: checked,
      disabledChecked: currentRole != RolesEnum.Administrator && currentRole != null && ((currentRole != RolesEnum.StoreOwner && currentRole >= role.id) || (currentRole == RolesEnum.StoreOwner && currentRole > role.id)),
      name: UtilityFunctions.spliByUpperCase(role.name),
      id: role.id
    });
  }
}
